import React from 'react';

class PrivacyPolice extends React.Component {

  render() {
    return (
      <div className="col-md-12 full-height">
        <div className="box box-default full-height">
          <div className="box-header">
            <h5>Políticas de Privacidad</h5>
          </div>
          <div className="box-body">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore
              magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
              commodo
              consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
              pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
              est laborum.</p>
          </div>
        </div>
      </div>
    );
  }
}

module.exports = PrivacyPolice;



// WEBPACK FOOTER //
// ./routes/privacy-police/index.js